export const motorcycles = [
  {
    id: 1,
    name: 'HARLEY-DAVIDSON',
    model: 'Harley-Davidson Sportster S 1250',
    type: 'Custom / Cruiser',
    seats: 2,
    engine: '1250 cm³',
    transmission: 'Manuelle 6 vitesses',
    fuel: 'Essence',
    power: '121 CH',
    pricePerDay: 149,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/c8f72ac6006d66db9d1d76c47c324951.jpeg',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/c8f72ac6006d66db9d1d76c47c324951.jpeg',
      'https://public.readdy.ai/ai/img_res/c9a72a76aa6df90e71e6f48baab59eb0.jpg',
      'https://readdy.ai/api/search-image?query=Harley-Davidson%20Sportster%20S%201250%20cockpit%20dashboard%20handlebar%20view%2C%20leather%20seat%20detail%2C%20chrome%20mirrors%2C%20warm%20sunlight%2C%20Cote%20d%20Azur%20road%20trip%20atmosphere%2C%20premium%20motorcycle%20rental&width=800&height=600&seq=moto1_detail&orientation=landscape'
    ],
    description: 'Icône américaine pour explorer la Côte d\'Azur en toute liberté. La Harley-Davidson Sportster S offre une expérience de conduite unique avec son moteur V-Twin Revolution Max et son style inimitable.',
    features: [
      'Moteur V-Twin Revolution Max',
      'Modes de conduite multiples',
      'Freinage ABS',
      'Contrôle de traction',
      'Selle confort 2 places',
      'Sacoches incluses'
    ]
  },
  {
    id: 2,
    name: 'BMW C1',
    model: 'BMW C1 200',
    type: 'Roadster / Naked',
    seats: 2,
    engine: '937 cm³',
    transmission: 'Manuelle 6 vitesses',
    fuel: 'Essence',
    power: '111 CH',
    pricePerDay: 129,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/2f22d1da954dd51f5baf6ccb4922f529.jpeg',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/2f22d1da954dd51f5baf6ccb4922f529.jpeg',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/af3283839ce3dd2ed791b720378f05a6.jpeg',
      'https://readdy.ai/api/search-image?query=Ducati%20Monster%20937%20cockpit%20view%2C%20round%20LED%20headlight%2C%20digital%20dashboard%2C%20red%20fuel%20tank%2C%20sporty%20handlebar%2C%20warm%20Mediterranean%20light%2C%20luxury%20motorcycle%20rental%20Cote%20d%20Azur&width=800&height=600&seq=moto2_detail&orientation=landscape'
    ],
    description: 'La légende italienne pour les amateurs de sensations fortes. Le Ducati Monster 937 allie design iconique et performances exceptionnelles pour des balades inoubliables sur les routes de la Riviera.',
    features: [
      'Moteur Testastretta 11°',
      'Modes Sport / Touring / Urban',
      'Cornering ABS',
      'Contrôle de traction DTC',
      'Quickshifter DQS',
      'Écran TFT couleur'
    ]
  },
  {
    id: 3,
    name: 'BMW R 1250 GS',
    model: 'BMW R 1250 GS Adventure',
    type: 'Trail / Adventure',
    seats: 2,
    engine: '1254 cm³',
    transmission: 'Manuelle 6 vitesses',
    fuel: 'Essence',
    power: '136 CH',
    pricePerDay: 159,
    image: 'https://readdy.ai/api/search-image?query=BMW%20R%201250%20GS%20Adventure%20motorcycle%20on%20mountain%20road%20near%20Nice%20French%20Alps%2C%20white%20and%20blue%20color%20scheme%2C%20adventure%20touring%20bike%2C%20panoramic%20landscape%2C%20professional%20automotive%20photography%2C%20clean%20scenic%20background&width=800&height=600&seq=moto3_cover&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=BMW%20R%201250%20GS%20Adventure%20motorcycle%20on%20mountain%20road%20near%20Nice%20French%20Alps%2C%20white%20and%20blue%20color%20scheme%2C%20adventure%20touring%20bike%2C%20panoramic%20landscape%2C%20professional%20automotive%20photography%2C%20clean%20scenic%20background&width=800&height=600&seq=moto3_cover&orientation=landscape',
      'https://readdy.ai/api/search-image?query=BMW%20R%201250%20GS%20Adventure%20side%20profile%2C%20boxer%20engine%20visible%2C%20white%20blue%20livery%2C%20large%20windscreen%2C%20panniers%2C%20studio%20clean%20background%2C%20premium%20adventure%20motorcycle%20rental&width=800&height=600&seq=moto3_side&orientation=landscape',
      'https://readdy.ai/api/search-image?query=BMW%20R%201250%20GS%20Adventure%20cockpit%20TFT%20display%2C%20heated%20grips%2C%20cruise%20control%20buttons%2C%20wide%20handlebar%2C%20comfortable%20touring%20seat%2C%20warm%20sunlight%2C%20Provence%20road%20trip%20atmosphere&width=800&height=600&seq=moto3_detail&orientation=landscape'
    ],
    description: 'La référence mondiale du trail pour partir à l\'aventure. Le BMW R 1250 GS Adventure est idéal pour explorer aussi bien les routes côtières que les cols alpins autour de la Côte d\'Azur.',
    features: [
      'Moteur Boxer ShiftCam',
      'Modes de conduite multiples',
      'Suspension semi-active',
      'Poignées chauffantes',
      'Régulateur de vitesse',
      'Top case inclus'
    ]
  }
];
